import { useState, useEffect } from 'react';
import { useApiClient } from '@forgetrack/api-client';

interface CurrentUser {
  userId: number;
  tenantId: number;
  role: string;
  isOwner: boolean;
  isAdmin: boolean;
}

let cachedUser: CurrentUser | null = null;

export function useCurrentUser() {
  const { createApi } = useApiClient();
  const [user, setUser] = useState<CurrentUser | null>(cachedUser);
  const [loading, setLoading] = useState(cachedUser === null);

  useEffect(() => {
    if (cachedUser) return;
    (async () => {
      try {
        const api = await createApi();
        const res = await api.get<CurrentUser>('/api/v1/me');
        cachedUser = res.data;
        setUser(res.data);
      } catch { /* silent */ }
      finally { setLoading(false); }
    })();
  }, [createApi]);

  return { user, loading, isAdmin: user?.isAdmin ?? false, isOwner: user?.isOwner ?? false, role: user?.role ?? 'Member' };
}
